module.exports = __webpack_public_path__ + "img/JO.52fe41df.png";